import * as React from "react";
const SvgFiRrFluxCapacitor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-flux-capacitor_svg__a)">
      <path
        fill="#062147"
        d="M19 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V5c0-2.757-2.243-5-5-5m3 19c0 1.654-1.346 3-3 3H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h14c1.654 0 3 1.346 3 3zm-11-3v-4.005L7.196 9.098a1.001 1.001 0 0 1 1.213-1.59L12 10.243l3.591-2.735a1 1 0 0 1 1.213 1.59L13 11.995v4.004a1 1 0 1 1-2 0zm-3.557-4.838a1 1 0 0 1-1.276.609A4.005 4.005 0 0 1 3.5 7.999c0-2.206 1.794-4 4-4 1.424 0 2.751.766 3.465 2A1 1 0 0 1 9.233 7a2 2 0 0 0-1.732-1c-1.103 0-2 .897-2 2 0 .847.536 1.604 1.333 1.886a1 1 0 0 1 .609 1.276M20.5 8a4.01 4.01 0 0 1-2.667 3.772 1 1 0 0 1-1.276-.609 1 1 0 0 1 .61-1.276A2 2 0 0 0 18.5 8.001c0-1.103-.897-2-2-2-.712 0-1.376.383-1.732 1A1.001 1.001 0 0 1 13.036 6a4.02 4.02 0 0 1 3.465-2A4.003 4.003 0 0 1 20.5 8m-4.728 6.667a4.02 4.02 0 0 1-.944 4.161A3.97 3.97 0 0 1 12 19.999a3.97 3.97 0 0 1-2.828-1.172 4.01 4.01 0 0 1-.944-4.161 1 1 0 1 1 1.886.666 2.007 2.007 0 0 0 .472 2.081c.756.757 2.072.756 2.828 0a2.01 2.01 0 0 0 .472-2.082 1 1 0 1 1 1.886-.664"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-flux-capacitor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFluxCapacitor;
